import config from './config.json';
import axios from 'axios';

const getOrgId = () => {
    return localStorage.getItem("orgId");
}

// Dashbord
export const getCountList = async (range) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/dashboard/count/" + range
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getMessageList = async (range) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_Batch_URL = config.API_URL + "/api/dashboard/lastmessages/" + range
    return axios.get(MOBILESURETY_Batch_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getSubmitList = async (range) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_Submit_URL = config.API_URL + "/api/dashboard/lastsubmits/" + range
    return axios.get(MOBILESURETY_Submit_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Company API
export const getClients = async (userName) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_CLIENT_URL = config.API_URL + "/api/clientlist/" + userName
    return axios.get(MOBILESURETY_CLIENT_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteClient = async (payload) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/client/delete"
    return axios.post(MOBILESURETY_URL, payload, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const updateClient = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/client/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateClient = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/client/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Region API
export const getRegions = async (userEmail) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_REGION_URL = config.API_URL + "/api/regionlist/" + userEmail
    return axios.get(MOBILESURETY_REGION_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteRegion = async (payload) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/region/delete"
    return axios.post(MOBILESURETY_URL, payload, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const updateCustomerRegion = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN
    const MOBILESURETY_URL = config.API_URL + "/api/region/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateCustomerRegion = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/region/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Site API
export const getSites = async (userEmail, clientId, regionId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_CUSTOMER_URL = config.API_URL + "/api/sitelist/" + userEmail + "/" + clientId + "/" + regionId
    return axios.get(MOBILESURETY_CUSTOMER_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteCustomer = async (recordId, deleteFlag) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/customer/delete/" + recordId + "/" + deleteFlag
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const siteApproveReject = async (id, userEmail, status) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/site/approval/" + id + "/" + userEmail + "/" + status
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getSitesId = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_USER_URL = config.API_URL + "/api/site/" + id
    return axios.get(MOBILESURETY_USER_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateSite = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/site/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Client User API
export const getClientUsers = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_USER_URL = config.API_URL + "/api/clientuser/all"
    return axios.post(MOBILESURETY_USER_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteClientUser = async (recordId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/clientuser/delete/" + recordId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getClientUserId = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/clientuser/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateClientUser = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/clientuser/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// FormSubmission API
export const searchFormSubmission = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspection/search"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const downloadPdf = async (pfreferenceId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_DOWNLOAD_URL = config.API_URL + "/api/formsearch/file/" + pfreferenceId
    return axios.get(MOBILESURETY_DOWNLOAD_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const approveReject = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspection/approval"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const sendUserEmail = async (pfreferenceId, postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/formsearch/sendemail/" + pfreferenceId
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteForm = async (pfreferenceId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/formSearch/" + pfreferenceId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const downloadcsv = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspection/export"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Scheduler API
export const getSChedule = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/schedule"
    return axios.get(MOBILESURETY_SCHEDULE_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const searchSchedule = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/schedule/search"
    return axios.post(MOBILESURETY_SCHEDULE_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteSchedule = async (recordId, userEmail) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/schedule/delete/" + recordId + "/" + userEmail
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getScheduleListId = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/schedule/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getCompany = async (userEmail) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_CLIENT_URL = config.API_URL + "/api/clientlistbasic/" + userEmail
    return axios.get(MOBILESURETY_CLIENT_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getRegion = async (company) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_REGION_URL = config.API_URL + "/api/region/basic/" + company
    return axios.get(MOBILESURETY_REGION_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getArea = async (regionId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_REGION_URL = config.API_URL + "/api/areabasic/" + regionId
    return axios.get(MOBILESURETY_REGION_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getScheduleSiteData = async (userEmail, company, region, newArea) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/sitelist/" + userEmail + "/" + company + "/" + region + "/" + newArea
    return axios.get(MOBILESURETY_SCHEDULE_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const upload = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/rent/upload";
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateSchedule = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/schedule/add";
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Dispatch API
export const getDispatch = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/dispatch/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const searchDispatch = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/dispatch/search"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getUserData = async (userName) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employee/basic/" + userName
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getSiteData = async (userEmail) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/site/basic/" + userEmail
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getRouteData = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/routes/basic"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteDispatches = async (recordId, userName) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/dispatch/delete/" + recordId + "/" + userName
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const approveRejectDispatch = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/dispatch/approval"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// UserProfile API
export const getEmployee = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employee/basic"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteUserProfile = async (recordId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employee/delete/" + recordId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getUserProfileId = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employee/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getManagerList = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employeelist"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateUserProfile = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employee/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getEmployeePicture = async (userEmail) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/employee/picture/" + userEmail
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// Super_Admin userProfile
export const getUserList = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/users"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateUser = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/user"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getUserId = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/user/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteUser = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/user/" + id
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


//  Org API
export const getOrgList = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/Auth/org/list"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
};

export const getOrgListId = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/Auth/org/byId/" + recordedId
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteOrg = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/org/byId/" + recordedId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateOrg = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/org"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Resources Folder API
export const getFolderList = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/folderlist"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getFolderListById = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/folder/" + recordedId
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateFolder = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/folder/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteFolder = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/folder/" + recordedId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Resources Subfolder API
export const getSubfolderList = async (folderId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/subfolderlist/" + folderId
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getSubfolderListById = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/subfolder/" + recordedId
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateSubfolder = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/subfolder/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteSubfolder = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/subfolder/" + recordedId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Resource file API
export const getFileList = async (subFolderId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/filelist/" + subFolderId
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdateFile = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/file/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const fileDownload = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/file/" + recordedId
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteFile = async (recordedId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/resource/file/" + recordedId
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}


// Support Messages
export const getSupportMessage = async (message) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/support/message/" + message;
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getMarkReadMessage = async (messageId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/support/markread/" + messageId;
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// Certificate
export const getCertificate = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/certificate";
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getUserCertificate = async (userEmail) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/certificate/" + userEmail;
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const downloadCertificate = async (pfreferenceId) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_DOWNLOAD_URL = config.API_URL + "/api/certificate/file/" + pfreferenceId
    return axios.get(MOBILESURETY_DOWNLOAD_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// PayrollSync
export const getDateRange = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_DATE_URL = config.API_URL + "/api/daterange";
    return axios.get(MOBILESURETY_DATE_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getQuickbooksSync = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/quickbooks/submit";
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getEmail = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspection/sendemail"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// QuickBooks Sync Logs
export const getBatchDates = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/quickbooks/syncbatch"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getApprovalReject = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/quickbooks"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// Payroll Mapping
export const getStaticData = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL_STATIC_DATA = config.API_URL + "/api/quickbooks/staticdata"
    return axios.get(MOBILESURETY_URL_STATIC_DATA, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getFormTypes = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL_STATIC_DATA = config.API_URL + "/api/formtypes"
    return axios.get(MOBILESURETY_URL_STATIC_DATA, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getPayrollMap = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/payrollmap"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getUpdatePayrollMap = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/payrollmap/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deletePayrollMapping = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/payrollmap/delete/" + id
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdatePayrollMapping = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/payrollmap/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getQuickBookOnline = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_SYNC_URL = config.API_URL + "/api/quickbooks/online"
    return axios.get(MOBILESURETY_SYNC_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// Schedule
export const getTrainingList = async () => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/traininglist"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addUpdatetrainingEvent = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/training/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getTrainingListById = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/training/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteTrainingEvent = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/training/delete/" + id
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// View Participants
export const ViewParticipantsList = async () => {
    const orgId = getOrgId();
    const token = config.API_URL;
    const MOBILESURETY_URL = config.API_URL + "/api/trainingreglist"
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getViewParticipantsList = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/trainingreg/bytraining/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addViewParticipants = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/trainingreg/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getViewParticipantsListById = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/trainingreg/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const deleteViewParticipantsList = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/trainingreg/delete/" + id
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

// Site Assignment
export const getSiteAssignmentList = async (year = 0, month = 0) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspectionallocationlist?year=" + year + "&month=" + month;
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const addSiteAssignment = async (postData) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspectionallocation/add"
    return axios.post(MOBILESURETY_URL, postData, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    });
}

export const getSiteAssignmentListById = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspectionallocation/" + id
    return axios.get(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    })
}

export const deleteSiteAssignment = async (id) => {
    const orgId = getOrgId();
    const token = config.TOKEN;
    const MOBILESURETY_URL = config.API_URL + "/api/inspectionallocation/delete/" + id
    return axios.delete(MOBILESURETY_URL, {
        headers: {
            "X-Org-Id": orgId,
            "Authorization": `Basic ${token}`
        }
    })
}